import axios from "axios";
import { Message } from 'element-ui'
const service = axios.create({
    baseURL: process.env.VUE_APP_OAUTH_SERVER_URL,
    timeout: 30000,
})

// 拦截request ,设置全局请求为ajax请求
service.interceptors.request.use(config => {
    config.headers.common["X-Requested-With"] = "XMLHttpRequest";
    // let token;
    // if((token = store.getters.token)){
    //     config.headers.common['Authorization'] = 'Bearer ' + token;
    // }
    return config;
})

service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.code == 200 || response.status === 200) {
            //200时返回0001状态码处理
            if(res.resultCode === '0001'){
                Message({
                    type:"warning",
                    message: res.resultDesc,
                    showClose: true
                })
            }
            return res;
        }
        const err = new Error(res.msg);
        err.data = res;
        err.message = res.msg;
        throw err;
    },
    err => {
        //返回状态码不为200时的错误处理
        if (err && err.response) {
            switch (err.response.status) {
                case 400:
                    err.message = `${err.response.data.resultDesc}`;
                    break;
                case 401:
                    err.message = "未授权，请登录";
                    break;
                case 403:
                    err.message = "拒绝访问";
                    break;
                case 404:
                    err.message = `请求地址出错`;
                    break;
                case 408:
                    err.message = "请求超时";
                    break;
                case 500:
                    err.message = "服务器内部错误";
                    break;
                case 501:
                    err.message = "服务未实现";
                    break;
                case 502:
                    err.message = "网关错误";
                    break;
                case 503:
                    err.message = "服务不可用";
                    break;
                case 504:
                    err.message = "网关超时";
                    break;
                case 505:
                    err.message = "HTTP版本不受支持";
                    break;
            }
            Message({
                type: 'error',
                message: err.message,
                showClose: true
            })
            
        }
        return Promise.reject(err);
    }
)
export default service
